import React from "react";
import { Button } from "./../../../shadcn/components/ui/button";
import { Badge } from "./../../../shadcn/components/ui/badge";
/*
eg:
<PostYourPropertyCard
          title="Do you own property and would want to put it up for auction?"
          buttonText="Post Your Property"
          onButtonClick={() => {}}
          imageSrc="./addNewProperty.png"
          imageAlt="Property Image"
        />
*/

interface PostYourPropertyCardProps {
  title: string;
  onButtonClick: any;
  buttonText: string;
  imageSrc: string;
  imageAlt: string;
  styles?: {
    wrapper?: string;
    titleWrapper?: string;
    title?: string;
    buttonWrapper?: string;
    button?: string;
    imageWrapper?: string;
    image?: string;
  };
}

const PostYourPropertyCard = ({
  title,
  onButtonClick,
  buttonText,
  imageSrc,
  imageAlt,
  styles,
}: PostYourPropertyCardProps) => {
  return (
    <div
      className={`max-w-[260px] bg-brand-lightBlue bg-wave-pattern1 bg-no-repeat bg-contain clip-path-mobileClipPolygonBottomRight hover:shadow-lg hover:scale-[1.01] hover:shadow-300 hover:duration-300 hover:ease-out ${styles?.wrapper}`}
    >
      <div
        className={`pl-4 pr-[42px] mobile:pr-[56px] pt-4 ${styles?.titleWrapper}`}
      >
        <p
          className={`font-openSans font-semibold text-web-body-lg leading-[26px] text-brand-textBlack ${styles?.title}`}
        >
          {title}
        </p>

        <div className={`pt-6 pb-[45px] ${styles?.buttonWrapper}`}>
          <Button
            className={`text-base px-4 py-6 flex-col  font-openSans font-semibold ${styles?.buttonWrapper}`}
            onClick={
              process.env.NEXT_PUBLIC_PYP_ENABLE === "true"
                ? onButtonClick
                : () => {}
            }
          >
            {buttonText}
            <Badge className="bg-[#ACE459]  py-0 my-1 rounded-sm text-[10px] font-semibold text-brand-bgBlack leading-3">
              FREE
            </Badge>
          </Button>
        </div>
      </div>

      <div className={`${styles?.imageWrapper}`}>
        <img
          src={imageSrc}
          alt={imageAlt}
          className={`max-w-[200px] object-cover ${styles?.image}`}
        />
      </div>
    </div>
  );
};

export default PostYourPropertyCard;
